import { FraudDetectionLog } from "@/types";
import { ColumnDef } from "@tanstack/react-table";

export const fraudLogColumns: ColumnDef<FraudDetectionLog>[] = [
  { accessorKey: "id", header: "ID" },
  { accessorKey: "playerId", header: "Player ID" },
  { accessorKey: "issue", header: "Issue" },

  {
    accessorKey: "riskLevel",
    header: "Risk",
    cell: ({ row }) => {
      const level = row.original.riskLevel;

      const color =
        level === "High"
          ? "text-red-500"
          : level === "Medium"
          ? "text-yellow-500"
          : "text-green-500";

      return <span className={`font-semibold ${color}`}>{level}</span>;
    },
  },

  {
    accessorKey: "timestamp",
    header: "Time",
    cell: ({ row }) =>
      new Date(row.original.timestamp).toLocaleString("en-IN"),
  },
];
